// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Flag_wrapper_2SkQh"};